import React from 'react'
import { ForEachModel, useValue, ValueToCollection } from '@morningtrain/react-resources'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import SmartviewText from '../../smartviews/partials/SmartviewText'
import SmartviewTextGroup from '../../smartviews/partials/SmartviewTextGroup'
import SmartviewContentSection from '../../smartviews/partials/SmartviewContentSection'
import { NavigateOnPipe } from '@morningtrain/react-navigation'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'

export default function ChecklistSmartviewSection () {
  const category = useValue('key')

  const icon = category === 'kitchen' ? <UI.Icons.Chef /> : <UI.Icons.Plates />

  return (
    <SmartviewContentSection>
      <UI.Text weight='medium' className='mb-4' block>
        <UI.WithIcon icon={icon} size={8} space='space-x-4'>
          <Displays.Enum name='key' enum='employment_type_category' />
        </UI.WithIcon>
      </UI.Text>

      <SmartviewTextGroup highlight highlightSize='card'>
        <ValueToCollection name='collection'>
          <ForEachModel>

            <Pipeline>
              <TriggerPipelineOnClick>

                <SmartviewText className='cursor-pointer'>
                  <UI.SpaceBetween>
                    <UI.WithSubtitle subtitle={(
                      <UI.Text size='xs' block className='w-full'>
                        <Displays.Enum name='type' enum='checklist_type' />
                      </UI.Text>
                    )}
                    >
                      <UI.Text color='black' size='base'>
                        <Displays.Text name='name' />
                      </UI.Text>
                    </UI.WithSubtitle>

                    <UI.Text weight='medium' size='base' align='right'>
                      <UI.WithSubtitle subtitle={(
                        <UI.Text size='xs' block className='w-full'>
                          <Displays.Number decimals={0} name='fill_percentage' />%
                        </UI.Text>
                      )}
                      >
                        <div>
                          <Displays.Text name='filled_fields_count' />/<Displays.Text name='fields_count' />
                        </div>
                      </UI.WithSubtitle>
                    </UI.Text>
                  </UI.SpaceBetween>
                </SmartviewText>
              </TriggerPipelineOnClick>
              <NavigateOnPipe route='app.view_checklist' routeParameters={{ checklist: 'model:id' }} />
            </Pipeline>

          </ForEachModel>
        </ValueToCollection>
      </SmartviewTextGroup>
    </SmartviewContentSection>
  )
}
